<template>
    <v-card
        class="mx-auto overflow-hidden layout"
    >
    <AppBar />
    <Sidebar class="sidebar" />
    <v-main class="content pt-0" style="padding-left:256px;">
        <router-view />
    </v-main>
    </v-card>
</template>
<script>
    import AppBar from '@/components/common/AppBar';
    import Sidebar from '@/components/common/Sidebar';
    export default {
        name: 'Layout',
        components: {AppBar, Sidebar },
    };
</script>
<style scoped>
.layout {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
/* .sidebar {
    overflow-y: scroll;
} */
.content {
    flex: 1;
    overflow-y: scroll; /* it works! */
    background-color: #f1f4f6 !important;
}
</style>
